<template>
  <div class="page-container">
    <div class="page-header">
      <h1 class="page-title">资讯中心</h1>
   
    </div>
    
    <div class="main-content">
      <!-- 内容区 -->
      <main class="content-area">
        <!-- <div class="content-header">
          <h2 class="content-title">资讯</h2>
          <span class="content-count">共 {{ newsList.length }} 条</span>
        </div> -->
        
        <div class="news-list">
          <div 
            v-for="news in newsList" 
            :key="news.id"
            @click="viewNewsDetail(news)"
            class="news-card"
          >
            <div class="news-header">
            
              <span class="news-date">{{ news.date }}</span>
            </div>
            <h3 class="news-title">{{ news.title }}</h3>
            <p class="news-summary">{{ news.summary }}</p>
            <div class="news-footer">
              <span class="view-count">
                <i class="fa fa-eye"></i>
                {{ news.viewCount }}次浏览
              </span>
              <span class="read-more">查看详情 →</span>
            </div>
          </div>
          
          <div v-if="newsList.length === 0" class="empty-state">
            <span class="empty-icon">📭</span>
            <p>暂无资讯</p>
          </div>
        </div>
        
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            background
            layout="prev, pager, next, jumper, ->, total"
            :total="total"
            :page-size="pageSize"
            v-model:current-page="currentPage"
            @current-change="handlePageChange"
          />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { getInformationList } from "@/api/newsApi";

export default {
  name: "NewsCenter",
  components: {},
  data() {
    return {
      isLoading: false,
      newsList: [],
      // 分页参数
      currentPage: 1,
      pageSize: 5,
      total: 0,
      pages: 0
    };
  },
  mounted() {
    // 检查 URL 参数中是否有页码，如果有则使用该页码
    const page = this.$route.query.page;
    if (page) {
      this.currentPage = parseInt(page);
    }
    this.fetchNewsList(this.currentPage, this.pageSize);
  },
  computed: {},
  watch: {
    '$route.query.page': function(newPage) {
      if (newPage) {
        const pageNum = parseInt(newPage);
        if (pageNum !== this.currentPage) {
          this.currentPage = pageNum;
          this.fetchNewsList(pageNum, this.pageSize);
        }
      }
    }
  },
  methods: {
    fetchNewsList(pageNum = 1, pageSize = this.pageSize) {
      this.isLoading = true;
      getInformationList(pageNum, pageSize).then(response => {
        console.log('资讯列表接口返回:', response.data);
        if (response.data.code === 200) {
          const data = response.data.data;
          console.log('数据列表:', data);
          
          if (data && data.list) {
            this.newsList = data.list.map(item => ({
              id: item.id,
              title: item.title,
              date: item.publishTime,
              viewCount: item.readingvolume,
              summary: this.getSummary(item.content),
              category: 'news'
            }));
            
            // 更新分页信息
            this.total = data.total || 0;
            this.currentPage = data.pageNum || 1;
            this.pageSize = data.pageSize || 5;
            this.pages = data.pages || 0;
            
            console.log('处理后的newsList:', this.newsList);
          } else {
            console.error('数据结构不符合预期:', response.data.data);
            this.newsList = [];
          }
        }
      }).catch(error => {
        console.error('获取资讯列表失败:', error);
        this.newsList = [];
      }).finally(() => {
        this.isLoading = false;
      });
    },
    
    getSummary(content) {
      if (!content) return '';
      const text = content.replace(/<[^>]*>/g, '').trim();
      return text.length > 100 ? text.substring(0, 100) + '...' : text;
    },
    
    handlePageChange(pageNum) {
      this.currentPage = pageNum;
      this.fetchNewsList(pageNum, this.pageSize);
    },
    
    viewNewsDetail(news) {
      // 跳转到详情页面，携带当前页码
      this.$router.push({
        path: `/news-center/detail/${news.id}`,
        query: { page: this.currentPage }
      });
    },
  }
};
</script>

<style scoped>
.page-container {
  margin-top: 60px;
  padding: 10px;
  background: linear-gradient(135deg, #f3e5f5 0%, #f0f4f8 100%);
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.page-title {
  font-size: 32px;
  color: #7b1fa2;
  margin: 0 0 8px 0;
  font-weight: bold;
}

.page-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.main-content {
  max-width: 1440px;
  width: calc(100% - 20px);
  margin: 0 auto;
}

/* 内容区 */
.content-area {
  width: 100%;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.content-title {
  font-size: 20px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.content-count {
  font-size: 14px;
  color: #999;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.news-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.category-tag {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 500;
}

.category-tag.large {
  font-size: 14px;
  padding: 6px 14px;
}

.category-tag.policy {
  background: #e8f5e9;
  color: #388e3c;
}

.category-tag.guide {
  background: #e3f2fd;
  color: #1976d2;
}

.category-tag.experience {
  background: #fff8e1;
  color: #f57c00;
}

.category-tag.news {
  background: #fce4ec;
  color: #c2185b;
}

.news-date {
  font-size: 12px;
  color: #999;
}

.news-title {
  font-size: 18px;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: 600;
  line-height: 1.4;
}

.news-summary {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 15px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px dashed #eee;
}

.view-count {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 4px;
}

.read-more {
  font-size: 14px;
  color: #7b1fa2;
  font-weight: 500;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
}

.empty-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

.empty-state p {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.detail-modal {
  background: white;
  border-radius: 16px;
  width: calc(100% - 40px);
  max-width: 90%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.header-left {
  display: flex;
  align-items: center;
}

.close-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.close-btn:hover {
  background: #e0e0e0;
  color: #333;
  transform: rotate(90deg);
}

.modal-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  background: linear-gradient(180deg, #fff 0%, #fafafa 100%);
  box-sizing: border-box;
  width: 100%;
}

.detail-title {
  font-size: 24px;
  color: #333;
  margin: 0 0 16px 0;
  font-weight: 600;
  line-height: 1.5;
  padding-bottom: 16px;
  border-bottom: 2px solid #e0e0e0;
}

.detail-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.detail-date, .detail-views {
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail-body {
  font-size: 16px;
  color: #444;
  line-height: 2;
  padding-top: 16px;
  word-break: break-all;
}

.detail-body p {
  margin: 0 0 16px 0;
  text-indent: 2em;
}

.detail-body img {
  max-width: calc(100% - 32px) !important;
  max-height: 38vh !important;
  width: auto !important;
  height: auto !important;
  display: block !important;
  margin: 8px auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: contain;
}


.detail-body h4 {
  font-size: 18px;
  color: #333;
  margin: 24px 0 12px 0;
  font-weight: 600;
  padding-left: 12px;
  border-left: 4px solid #7b1fa2;
}

.detail-body strong {
  color: #7b1fa2;
  font-weight: 600;
}

.detail-body em {
  font-style: italic;
  color: #666;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.close-modal-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .nav-item {
    padding: 12px 16px;
  }
  
  .page-title {
    font-size: 26px;
  }
  
  .news-card {
    padding: 15px;
  }
  
  .news-title {
    font-size: 16px;
  }
  
  .content-title {
    font-size: 18px;
  }
  
  .detail-title {
    font-size: 18px;
  }
}
</style>